<ng-container *ngIf="!showInTooltip || !isVisible">
  <div class="tcm-tax-wrapper-container" [class.display-inline] ="showInTooltip">
    <div class="tcm-tax-wrapper-container-inner" [class.display-inline] ="showInTooltip">
      <ng-content></ng-content>
      <ng-container *ngTemplateOutlet="contentTpl?.templateRef"></ng-container>
      <span *ngIf="value && isVisible && showRight"
            class="tcm-tax-wrapper-value">
        ({{taxValue | wafCurrency}} {{textValue}})
      </span>
    </div>
    <span *ngIf="value && isVisible && (showBottom || !showRight)"
          class="tcm-tax-wrapper-value">
      ({{taxValue | wafCurrency}} {{textValue}})
    </span>
  </div>
</ng-container>


<ng-container *ngIf="showInTooltip && isVisible">
  <ng-template #taxTooltip>    
    <div class="tcm-tax-wrapper-container">
      <div class="tcm-tax-wrapper-container-inner">
        <b><ng-container *ngTemplateOutlet="contentTpl?.templateRef"></ng-container></b>
        <span *ngIf="value && isVisible && showRight"
              class="tcm-tax-wrapper-value">
          ({{taxValue | wafCurrency}} {{textValue}})
        </span>
      </div>
      <span *ngIf="value && isVisible && (showBottom || !showRight)"
            class="tcm-tax-wrapper-value">
        ({{taxValue | wafCurrency}} {{textValue}})
      </span>
    </div>
  </ng-template>

  <a class="taxable-tooltip-link"
     [ngbTooltip]="taxTooltip"     
     triggers="hover"
     placement="right">
    <ng-container *ngTemplateOutlet="contentTpl?.templateRef"></ng-container>
  </a>
</ng-container>
